import React from 'react';
import { RunInfoPage } from './RunInfoPage';

export const RunInfoAdapter: React.FC = () => {
  return <RunInfoPage />;
};
